/* ============
 * Date Util
 * ============
 */
import moment from 'moment-timezone';
import timeSlotUtil from './timeSlot';

const formatDateTime = (date, oldFormat) => {
  const stillUtc = moment.tz(date, oldFormat);
  return stillUtc.format('DD/MM/YYYY HH:mm');
};
const formatDate = (date) => {
  const stillUtc = moment.tz(date, timeSlotUtil.getLocalTimeZone());
  return stillUtc.format('DD/MM/YYYY');
};
const formateDateTime12Hours = (date) => {
  const stillUtc = moment.tz(date, timeSlotUtil.getLocalTimeZone());
  return stillUtc.format('MMM D, Y, hh:mm A');
};
const formateDateTimeForDisplay = (date, format) => {
  if (date) {
    const stillUtc = moment.tz(date, timeSlotUtil.getLocalTimeZone());
    return stillUtc.format(format ? format : 'DD/MM/YYYY HH:mm');
  } else return '-';
};
const formatDateTimeFromTimeStamp = (date, format) => {
  if (date) {
    const stillUtc = moment.tz(date * 1000, timeSlotUtil.getLocalTimeZone());
    return stillUtc.format(format ? format : 'DD/MM/YYYY HH:mm');
  } else return '-';
};
const formatDateFromTimeStamp = (date) => {
  if (date) {
    const stillUtc = moment.tz(date * 1000, timeSlotUtil.getLocalTimeZone());
    return stillUtc.format('DD/MM/YYYY');
  } else return '-';
};

const formatDateTimeForPayload = (date, time) => {
  let stillUtc;
  if (time) {
    stillUtc = moment.tz(`${date} ${time}`, timeSlotUtil.getLocalTimeZone()).tz('UTC');
  } else {
    stillUtc = moment.tz(`${date}`, timeSlotUtil.getLocalTimeZone()).tz('UTC');
  }

  return stillUtc.format('Y-MM-DD HH:mm:ss');
};

const formatFromISO8601 = (iso8601, format) => {
  return moment(iso8601).tz(getLocalTimeZone()).format(format);
};

const getLocalTimeZone = () => timeSlotUtil.getLocalTimeZone() || moment.tz.guess();

export default {
  formatDateTimeFromTimeStamp,
  formatDateFromTimeStamp,
  formatDateTime,
  formatDate,
  formatDateTimeForPayload,
  getLocalTimeZone,
  formatFromISO8601,
  formateDateTime12Hours,
  formateDateTimeForDisplay,
  formatTime(date) {
    return moment(date).format('HH:mm');
  },

  formattedTimePeriod(date, addHour) {
    if (addHour) {
      return moment
        .tz(date * 1000, timeSlotUtil.getLocalTimeZone())
        .add(addHour, 'hour')
        .format('DD/MM/YYYY HH:mm');
    }
    return formatDateTimeFromTimeStamp(date);
  },

  normalizedDateFormat(dateStr) {
    const dateDataArr = dateStr.split('/');
    if (dateDataArr.length === 3) {
      if (dateDataArr[0].length < dateDataArr[2].length) {
        const temp = dateDataArr[0];
        dateDataArr[0] = dateDataArr[2];
        dateDataArr[2] = temp;
      }
    }
    return dateDataArr.join('-');
  },

  revertNormalizedDateFormat(dateStr) {
    const dateDataArr = dateStr.split('-');
    if (dateDataArr.length === 3) {
      if (dateDataArr[0].length > dateDataArr[2].length) {
        const temp = dateDataArr[0];
        dateDataArr[0] = dateDataArr[2];
        dateDataArr[2] = temp;
      }
    }
    return dateDataArr.join('/');
  },

  revertFormatDateTimeForPayload(dateStr) {
    const dateDataArr = dateStr.split(' ');
    const date = dateDataArr[0].split('/');
    if (date.length === 3) {
      if (date[0].length < date[2].length) {
        const temp = date[0];
        date[0] = date[2];
        date[2] = temp;
      }
    }
    return `${date.join('-')} ${dateDataArr[1]}`;
  },

  computeAge(birthdate) {
    return moment().diff(moment(birthdate), 'years');
  },

  dayOfWeekKeyForMoment(dateMoment) {
    return dateMoment.format('dddd').toLowerCase();
  },

  daysOfWeek() {
    return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  },

  daysOfWeekMin() {
    return ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  },
};
